import { SubcategoryRequest } from '@/main/models/request/subcategoryRequest';
import { SubcategoryTypes, SubcategoryActionTypes } from './subcategoryTypes';
import { CategoryResponse } from '@/main/models/response';

export function getSubcategory(
  request: SubcategoryRequest,
  keyReducer: string = 'default'
): SubcategoryActionTypes {
  return {
    type: SubcategoryTypes.GET_SUBCATEGORY,
    payload: { request, keyReducer }
  };
}

export function saveSubcategory(
  data: CategoryResponse[] | null,
  isError: boolean,
  errorMessages: string[] | null,
  keyReducer: string = 'default'
): SubcategoryActionTypes {
  return {
    type: SubcategoryTypes.SAVE_SUBCATEGORY,
    payload: { data, isError, errorMessages, keyReducer }
  };
}

export function resetReducerSubcategory(
  keyReducer: string = 'default'
): SubcategoryActionTypes {
  return {
    type: SubcategoryTypes.RESET_REDUCER_SUBCATEGORY,
    payload: { keyReducer }
  };
}

